/* eslint-disable
    eqeqeq,
    no-prototype-builtins,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let query;
const f = require('effing');
const valueUnion = require('app/scripts/lib/util/value-union');
const _ = require('underscore');
const Queries = require('app/scripts/network/quick-queries');
const { Analytics, getScreenFromUrl } = require('@trello/atlassian-analytics');

const Payloads = {};

for (const key in Queries) {
  query = Queries[key];
  if (_.isObject(query)) {
    Payloads[key] = { query };
  } else if (_.isString(query)) {
    Payloads[key] = query;
  } else {
    throw new Error('Implicit coupling fell over');
  }
}

const orgBoardsMapping = function (deltaBoards, model) {
  const idBoards = _.pluck(deltaBoards, 'id');
  return model.set('idBoards', idBoards);
};

Payloads.organizationBoardsPage.mappingRules = { boards: orgBoardsMapping };

const attachmentsUnion = function (deltaAttachments, model) {
  let left;
  const currentAttachments =
    (left = model.get('attachments')) != null ? left : [];
  const newAttachments = valueUnion(
    f.get('id'),
    currentAttachments,
    deltaAttachments,
  );
  return model.set('attachments', newAttachments);
};

Payloads.currentBoardMinimal.mappingRules = { attachments: attachmentsUnion };

Payloads.currentBoardPluginData.mappingRules = {
  attachments: attachmentsUnion,
};

// Assumes that board.cards and board.lists are both included, that closed
// cards/lists are not included, that the cards have the idList and pos
// fields defined and that lists have the pos field defined
const knownBoards = {};
const deprioritizeHiddenCards = function (board, modelCache) {
  knownBoards[board.id] = true;

  const { cards, lists } = board;

  // Hard coded list width
  const maxVisibleLists = Math.max(3, Math.ceil(window.innerWidth / 270));

  _.sortBy(lists, 'pos').forEach(
    (list, index) =>
      (list._visible =
        index < maxVisibleLists ||
        // We don't want to delay loading cards for lists we already know about
        modelCache.get('List', list.id) != null),
  );

  let boardHasOrphanedCards = false;

  const listsById = _.indexBy(lists, 'id');
  _.chain(cards)
    .groupBy('idList')
    .values()
    .map((listCards) => {
      return _.sortBy(listCards, 'pos').forEach(function (card, index) {
        const list = listsById[card.idList];
        if (list != null) {
          card._visible = list._visible;
        } else {
          boardHasOrphanedCards = true;
          card._visible = false;
        }
      });
    });

  if (boardHasOrphanedCards) {
    Analytics.sendOperationalEvent({
      actionSubject: 'orphanedCards',
      action: 'errored',
      source: getScreenFromUrl(),
      containers: {
        board: {
          id: board.id,
        },
      },
    });
  }

  const listsByVisible = _.groupBy(board.lists, '_visible');
  board.lists.forEach((list) => delete list._visible);

  const cardsByVisible = _.groupBy(board.cards, '_visible');
  board.cards.forEach((card) => delete card._visible);

  const deferredBoard = { id: board.id };

  // NOTE: It makes a difference having the cards come before the lists
  // on the response and deferred response, we want the cards to be first
  // so they're already known when the list is initialized (and so they
  // aren't procesed as "adds" to the list's cardList)
  deferredBoard.cards =
    cardsByVisible[false] != null ? cardsByVisible[false] : [];
  deferredBoard.lists =
    listsByVisible[false] != null ? listsByVisible[false] : [];

  board.cards = cardsByVisible[true] != null ? cardsByVisible[true] : [];
  board.lists = listsByVisible[true] != null ? listsByVisible[true] : [];

  if (deferredBoard.lists.length > 0 || deferredBoard.cards.length > 0) {
    return { data: board, deferred: deferredBoard };
  } else {
    return { data: board };
  }
};

const afterInitialLoad = function (board) {
  if (knownBoards.hasOwnProperty(board.id)) {
    return { data: board };
  } else {
    return { deferred: board };
  }
};

// Have a version of board loading without any splitDeferred (always load
// all cards immediately)
Payloads.currentCalendarMinimal = _.clone(Payloads.currentBoardMinimal);
Payloads.currentCalendarMinimal.query.boardPlugins = true;

Payloads.currentBoardMinimal.splitDeferred = deprioritizeHiddenCards;
Payloads.currentBoardPluginData.splitDeferred = afterInitialLoad;
Payloads.currentBoardSecondary.splitDeferred = afterInitialLoad;

Payloads.memberActions = [Payloads.boardActions, 'updateMember'].join(',');

Payloads.boardFieldsUnread = ['dateLastActivity', 'dateLastView'];

Payloads.boardAttachment = {
  query: {
    structure: 'all',
    structure_limit: 5,
    fields: 'name,prefs,shortLink,url',
  },
};

Payloads.boardFieldsMinimalMemberships = ['name', 'closed', 'memberships'].join(
  ',',
);

Payloads.organizationMembersBoardFields = [
  Payloads.boardFieldsMinimalMemberships,
  'idOrganization',
  'prefs',
].join(',');

Payloads.enterpriseMemberFields = [
  'active',
  'activityBlocked',
  'avatarUrl',
  'confirmed',
  'enterpriseActiveOrgCount',
  'enterpriseDeactivatedOrgCount',
  'fullName',
  'initials',
  'memberType',
  'nonPublic',
  'roles',
  'userType',
  'username',
  'memberEmail',
  'dateLastAccessed',
].join(',');

Payloads.enterpriseMinimum = {
  query: {
    fields: 'name,displayName',
  },
};

Payloads.enterprise = {
  query: {
    fields:
      'displayName,name,prefs,products,organizationPrefs,pluginWhitelistingEnabled,idPluginsAllowed,idp,logoHash,domains,isAtlassianOrg',
  },
};

Payloads.enterpriseOrganizationFields = [
  'name',
  'displayName',
  'logoHash',
  'memberships',
].join(',');

Payloads.organizationFieldsMinimalMemberships = [
  Payloads.organizationFieldsMinimal,
  'memberships',
];

Payloads.organizationFieldsMinimalMembershipsWithAvailableLicenseCount = [
  Payloads.organizationFieldsMinimalMemberships,
  'availableLicenseCount',
];

Payloads.organizationFieldsMembersPage = [
  Payloads.organizationBoardsFields,
  'memberships',
].join(',');

const membershipUnion = function (deltaMemberships, model) {
  let left;
  const currentMemberships =
    (left = model.get('memberships')) != null ? left : [];
  const newMemberships = valueUnion(
    f.get('id'),
    currentMemberships,
    deltaMemberships,
  );
  return model.set('memberships', newMemberships);
};

Payloads.organizationFieldsMembersPageWithAvailableLicenseCount = [
  Payloads.organizationBoardsFields,
  'availableLicenseCount',
].join(',');

Payloads.boardMinimal = {
  query: {
    fields: Payloads.boardFieldsMinimal,
    organization: true,
    organization_fields: Payloads.organizationFieldsMinimal,
    myPermLevel: true,
    memberships: 'me',
  },
  mappingRules: {
    memberships: membershipUnion,
  },
};

Payloads.boardChecklists = {
  query: {
    fields: '',
    cards: 'visible',
    card_fields: '',
    card_checklists: 'all',
  },
};

Payloads.boardCompleter = {
  query: {
    fields: 'closed,idOrganization,name,url',
  },
};

Payloads.boardsMenuMinimal = {
  query: {
    boards: 'open,starred',
    board_fields: Payloads.boardFieldsMinimal,
    boardStars: true,
    organizations: 'all',
    organization_fields: Payloads.organizationFieldsMinimal,
    board_organization: true,
    board_organization_fields: Payloads.organizationFieldsMinimal,
    board_myPermLevel: true,
    board_memberships: 'me',
  },
  mappingRules: {
    memberships: membershipUnion,
  },
};

Payloads.boardUnread = {
  query: {
    fields: Payloads.boardFieldsUnread,
  },
};

Payloads.cardDetails = {
  query: {
    actions: Payloads.cardActions,
    actions_display: true,
    action_memberCreator_fields: Payloads.memberFieldsAndPremOrgsAdmin,
    action_reactions: true,
    members: true,
    member_fields: Payloads.memberFields,
    attachments: true,
    fields: 'email',
    checklists: 'all',
    checklist_fields: 'all',
    list: true,
    pluginData: true,
    customFieldItems: true,
  },
};

Payloads.cardAttachment = {
  query: {
    board: true,
    members: true,
    member_fields: Payloads.memberFields,
    attachments: true,
    fields: 'all',
    checklists: 'all',
    list: true,
    pluginData: true,
    customFields: true,
    customFieldItems: true,
  },
};

Payloads.cardMinimal = {
  query: {
    fields: Payloads.cardFieldsBulk,
  },
};

Payloads.cardCompleter = {
  query: {
    fields: 'closed,idBoard,name,url',
    board: true,
    board_fields: 'name',
  },
};

Payloads.cardVoters = {
  query: {
    fields: 'idMembersVoted',
    membersVoted: true,
  },
};

Payloads.cardCopy = {
  query: {
    members: true,
    member_fields: Payloads.memberFields,
    attachments: true,
    stickers: true,
    fields: 'name',
    checklists: 'all',
  },
};

Payloads.customFields = {
  query: {
    fields: '',
    customFields: true,
    cards: 'visible',
    card_customFieldItems: true,
    card_fields: '',
  },
};

Payloads.memberAccount = {
  query: {
    tokens: 'all',
    sessions: 'all',
    credentials: 'all',
    logins: true,
    enterprises: true,
    enterprise_fields: 'prefs',
    token_plugins: true,
  },
};

Payloads.memberBilling = {
  query: {
    paidAccount: true,
    paidAccount_fields: 'all',
    credits: 'invitation,promoCode',
    organizations: 'all',
    organization_fields: 'displayName,name,prefs,products,url',
    organization_paidAccount: true,
    organization_paidAccount_fields: 'all',
  },
};

Payloads.orgMemberCards = {
  query: {
    board: true,
    list: true,
    fields:
      'badges,closed,dateLastActivity,due,dueComplete,idAttachmentCover,idList,idBoard,idMembers,idShort,labels,name,url',
    attachments: 'true',
    members: 'true',
    stickers: 'all',
    member_fields: Payloads.memberFields,
    board_fields: Payloads.boardFieldsMinimalMemberships,
  },
};

Payloads.memberCards = {
  query: {
    boards: 'open',
    board_fields: 'name,closed,idOrganization,prefs',
    board_lists: 'open',
    board_memberships: 'me',
    organizations: 'all',
    organization_fields: 'displayName,name,prefs,products,url',
    organization_memberships: 'me',
    organization_paidAccount: true,
    organization_paidAccount_fields: 'all',
    paidAccount: true,
    paidAccount_fields: 'all',
  },
  mappingRules: {
    memberships: membershipUnion,
  },
};

Payloads.memberMinimal = {
  query: {
    fields: Payloads.memberFields,
  },
};

Payloads.memberProfile = {
  query: {
    actions: 'all',
    actions_limit: 10,
    actions_display: true,
    organizations: 'all',
    organization_fields: Payloads.organizationFieldsMinimal,
    organization_paidAccount: true,
    organization_paidAccount_fields: 'all',
    boards: 'open',
    board_fields: 'name,prefs,idOrganization',
    paidAccount: true,
    paidAccount_fields: 'all',
  },
};

Payloads.memberProfile_daysBack = 30;

Payloads.organization = {
  query: {
    boards: 'open',
    board_fields: Payloads.boardFieldsMinimal,
    enterprise: true,
    fields: 'all',
    members: 'all',
    member_fields: Payloads.memberFields,
    membersInvited: 'all',
    membersInvited_fields: Payloads.memberFields,
    paidAccount: true,
    paidAccount_fields: 'all',
  },
  mappingRules: {
    boards: orgBoardsMapping,
  },
};

Payloads.organizationExports = {
  query: {
    exports: true,
    fields: 'all',
    paidAccount: true,
    paidAccount_fields: 'all',
    enterprise: true,
  },
};

Payloads.organizationMembers = {
  query: {
    fields: Payloads.organizationFieldsMembersPage,
    members: 'all',
    member_fields: Payloads.memberFields,
    member_activity: true,
    membersInvited: 'all',
    membersInvited_fields: Payloads.memberFields,
    paidAccount: true,
    paidAccount_fields: 'all',
    enterprise: true,
    tags: true,
  },
};

Payloads.organizationMembersWithAvailableLicenseCount = {
  query: {
    fields: Payloads.organizationFieldsMembersPageWithAvailableLicenseCount,
    members: 'all',
    member_fields: Payloads.memberFields,
    membersInvited: 'all',
    membersInvited_fields: Payloads.memberFields,
    paidAccount: true,
    paidAccount_fields: 'all',
    tags: true,
  },
};

Payloads.organizationMembersBoards = {
  query: {
    fields: '',
    boards: 'open',
    board_fields: Payloads.organizationMembersBoardFields,
  },
  mappingRules: {
    boards: orgBoardsMapping,
  },
};

Payloads.organizationMembersCollaborators = {
  query: {
    fields: '',
    collaborators: true,
  },
};

Payloads.organizationMembersMinimal = {
  query: {
    members: 'all',
    fields: Payloads.organizationFieldsMinimalMemberships,
  },
};

Payloads.organizationFieldsMinimalWithAvailableLicenseCount = {
  query: {
    members: 'all',
    fields:
      Payloads.organizationFieldsMinimalMembershipsWithAvailableLicenseCount,
  },
};

Payloads.organizationFieldsMaximumAndAvailableLicenseCount = {
  query: {
    fields: ['availableLicenseCount', 'maximumLicenseCount'],
  },
};

Payloads.organizationMinimal = {
  query: {
    fields: 'all',
    tags: true,
  },
};

Payloads.organizations = {
  query: {
    organizations: 'all',
    organization_paidAccount: true,
    organization_paidAccount_fields: 'all',
  },
};

Payloads.organizationsWithoutBoards = {
  query: {
    organizations: 'all',
    organization_paidAccount: true,
    organization_paidAccount_fields: 'all',
    organization_fields: 'name,displayName,logoHash,products,memberships',
    fields: '',
  },
};

Payloads.organizationsMemberships = {
  query: {
    organizations: 'all',
    organization_fields: 'memberships',
  },
};

Payloads.organizationCredits = {
  query: {
    credits: 'all',
    fields: 'id',
  },
};

Payloads.idCard = {
  query: {
    fields: '',
    checkItemStates: false,
  },
};

const DefaultBoardFields = [
  'name',
  'desc',
  'descData',
  'closed',
  'idOrganization',
  'pinned',
  'url',
  'shortUrl',
  'prefs',
  'labelNames',
];
Payloads.cardsAndListsMinimal = {
  query: {
    lists: 'open',
    list_fields: 'name,pos,idBoard,closed,limits',
    cards: 'visible',
    card_fields: 'idList,idBoard,pos,closed',
    fields: [...Array.from(DefaultBoardFields), 'limits'].join(','),
  },
};
Payloads.listsMinimal = {
  query: {
    lists: 'open',
    list_fields: 'name,pos,idBoard,closed',
    fields: 'limits',
  },
};

Payloads.listMinimal = {
  query: {
    fields: 'name,pos,idBoard,closed',
  },
};

Payloads.archivedLists = {
  query: {
    fields: 'id',
    lists: 'closed',
    list_fields: 'name,pos,idBoard,closed',
  },
};

Payloads.archivedListsAndCards = {
  query: {
    lists: 'closed',
    list_fields: 'name,pos,idBoard,closed',
    cards: 'open',
    card_fields: 'idList,idBoard,badges,pos,closed',
  },
};

Payloads.listCards = {
  query: {
    cards: 'open',
    card_fields: 'idList,idBoard,badges,pos,closed,name',
  },
};

Payloads.action = {
  query: {
    display: true,
    memberCreator: true,
  },
};

Payloads.memberOrganizationDeactivatedMembers = {
  query: {
    fields: Payloads.organizationFieldsMinimal,
    memberships: 'deactivated',
  },
  mappingRules: {
    memberships: membershipUnion,
  },
};

Payloads.pendingOrganizations = {
  mappingRules: {
    // The `memberRequestor` field gets detected by ModelCache
    // as a nested Member model, and will be removed from the
    // returned models. This mapping rule is in place to just stick that
    // field back on the models.
    memberRequestor(memberRequestor, model) {
      return model.set('memberRequestor', memberRequestor);
    },
  },
};

module.exports = Payloads;
